<template>
  <div class="row">
    <input-select
      class="col-12"
      :label="tipoLabel"
      v-model="form.tipo"
      :options="tipoOptions"
      ref="tipo"
      required
    />
    <input-textarea
      class="col-12"
      label="Descrição"
      :max-length="300"
      ref="descricao"
      v-model="form.descricao"
      placeholder="Máximo 300 caracteres"
      required
    />
    <input-textarea
      class="col-12"
      label="Justificativa"
      :max-length="500"
      ref="justificativa"
      v-model="form.justificativa"
      placeholder="Máximo 500 caracteres"
      required
    />

    <input-text
      class="col-12 col-md-4"
      label="Quantidade"
      ref="quantidade"
      v-model="form.quantidade"
      type="number"
      required
    />
    <input-money
      class="col-12 col-md-4"
      label="Valor individual"
      ref="valor"
      v-model="form.valorIndividual"
      required
    />
    <input-text
      class="col-12 col-md-4"
      label="Valor total"
      readonly
      v-model="total"
    />

    <input-select
      class="col-12 col-md-4"
      label="Origem da despesa"
      :options="options.origemDespesa"
      ref="origem"
      v-model="form.origemDespesa"
      required
    />
    <input-select
      class="col-12 col-md-4"
      label="Despesa de laboratório existente?"
      :options="options.simnao"
      ref="laboratorio_existente"
      v-model="form.despesaLaboratorioExistente"
      required
    />
    <input-select
      class="col-12 col-md-4"
      label="Despesa de laboratório novo?"
      :options="options.simnao"
      ref="laboratorio_novo"
      v-model="form.despesaLaboratorioNovo"
      required
    />

    <input-date-time
      class="col-12 col-md-3"
      label="Data de emissão"
      ref="data_emissao"
      v-model="form.dataEmissao"
      required
    />
    <input-select
      class="col-12 col-md-3"
      label="Tipo de documento"
      ref="tipo_documento"
      v-model="form.tipoDocumento"
      :options="options.tipoDocumentoProjeto"
      required
    />
    <input-text
      class="col-12 col-md-6"
      label="Nº do documento"
      ref="nr_documento"
      v-model="form.numeroDocumento"
      required
    />

    <input-text
      class="col-12"
      label="Beneficiado"
      ref="beneficiado"
      v-model="form.beneficiado"
      required
    />
    <div v-if="form.origemDespesa === 'Nacional' || form.origemDespesa == null" class="col-2 d-flex align-items-center justify-content-center">
      <b-form-radio-group
        :options="options.tipoDocumento"
        v-model="form.documento"
      ></b-form-radio-group>
    </div>
    <input-mask
      :type="form.documento ? (form.documento == 'CPF' ? 'cpf' : 'cnpj') : ''"
      class="col-10"
      :mask="
        form.documento
          ? form.documento == 'CPF'
            ? mascara.cpf
            : mascara.cnpj
          : ''
      "
      label="Documento"
      ref="numero"
      v-model="form.cpfcnpj"
      required
      v-if="form.origemDespesa === 'Nacional' ||form.origemDespesa == null "
    />
    <input-text v-else class="col-12"  label="Invoice"  ref="invoice" v-model="form.invoice" required/>

    <div class="col-12 mb-2">
      <upload v-if="!form.comprovanteAWS"
        id="comprovante"
        tituloArquivo="Arrastar comprovante"
        selecioneArquivo="Selecionar o comprovante"
        type=".*"
        @upload="(file, nomeArquivo) => {
            form.comprovanteArquivo = nomeArquivo;
            form.comprovanteBase64 = file;
            this.$forceUpdate();
          }
        "
        :arquivo-download="form.comprovanteBase64"
        :arquivo-download-nome="form.comprovanteArquivo"
      />

      <template v-if="form.comprovanteAWS">
          <div>
              Comprovante
              <div class="lista-arquivos d-flex">
                  <b-button variant="danger" @click="removerArquivo(tipoArquivoCusto.CP)" class="m-2" size="sm">
                      <b-icon icon="trash" class="mr-2" />
                      Remover
                  </b-button>
                  <b-button variant="info" @click="baixarArquivo(form.id, tipoArquivoCusto.CP)" class="m-2" size="sm">
                      <i class="fas fa-cloud-download"></i>
                  </b-button>
                  <div  style="border-left: 1px solid #e5e5e5;" class="lista-arquivos__left d-flex pl-2 align-items-center">
                      {{form.comprovanteAWS}}
                  </div>
              </div>
          </div>
      </template>
    </div>
    <div class="col-12 mb-2">
      <upload v-if="!form.liquidacaoFinanceiraAWS"
        id="liquidacao"
        tituloArquivo="Arrastar liquidação financeira"
        selecioneArquivo="Selecionar a liquidação financeira"
        type=".*"
        @upload="(file, nomeArquivo) => {
            form.liquidacaoFinanceiraArquivo = nomeArquivo;
            form.liquidacaoFinanceiraBase64 = file;
            this.$forceUpdate();
          }
        "
        :arquivo-download="form.liquidacaoFinanceiraBase64"
        :arquivo-download-nome="form.liquidacaoFinanceiraArquivo"
      />

      <template v-if="form.liquidacaoFinanceiraAWS">
          <div>
              Liquidacao Financeira
              <div class="lista-arquivos d-flex">
                  <b-button variant="danger" @click="removerArquivo(tipoArquivoCusto.LQ)" class="m-2" size="sm">
                      <b-icon icon="trash" class="mr-2" />
                      Remover
                  </b-button>
                  <b-button variant="info" @click="baixarArquivo(form.id, tipoArquivoCusto.LQ)" class="m-2" size="sm">
                      <i class="fas fa-cloud-download"></i>
                  </b-button>
                  <div  style="border-left: 1px solid #e5e5e5;" class="lista-arquivos__left d-flex pl-2 align-items-center">
                      {{form.liquidacaoFinanceiraAWS}}
                  </div>
              </div>
          </div>
      </template>
    </div>
  </div>
</template>
<script>
import InputText from "@/components/inputs/InputText";
import InputMask from "@/components/inputs/InputMask";
import InputSelect from "@/components/inputs/InputSelect";
import InputTextarea from "@/components/inputs/InputTextarea";
import InputDateTime from "@/components/inputs/InputDateTime";
import InputMoney from "@/components/inputs/InputMoney";
import Upload from "@/components/upload/Upload";

import helpers from "@/common/utils/helpers";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

import { FormMixin } from "@/common/mixins/FormMixin";

export default {
  name: "realizado",
  mixins: [FormMixin],
  components: {
    InputText,
    InputMask,
    InputSelect,
    InputTextarea,
    InputDateTime,
    InputMoney,
    Upload,
  },
  props: {
    projeto: {
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    tipoLabel: {
      type: String,
      default: "Tipo de recurso",
    },
    tipoOptions: {
      default: [],
    },
  },
  data: () => ({
    options: {
      empresas: [],
      tipoDocumento: [
        { value: "CPF", text: "CPF" },
        { value: "CNPJ", text: "CNPJ" },
      ],
      tipoDocumentoProjeto: helpers.getTiposDocumentoProjeto(),
      origemDespesa: helpers.getOrigensDepesas(),
      simnao: [
        { value: "S", text: "Sim" },
        { value: "N", text: "Não" },
      ],
    },
    mascara: {
      cpf: "###.###.###-##",
      cnpj: "##.###.###/####-##",
    },
    tipoArquivoCusto : {
        CP: "CP",
        LQ: "LQ",
    }
  }),
  methods: {
    baixarArquivo: function(id, arquivoTipo){
      this.$emit('baixarArquivoAWS', id, arquivoTipo);
    },
    removerArquivo: function(arquivoTipo){
        this.$store.dispatch(START_LOADING);

        if(arquivoTipo == "CP")
            this.form.comprovanteAWS = null;
        else 
            this.form.liquidacaoFinanceiraAWS = null;

        this.$store.dispatch(STOP_LOADING);
    }
  },
  computed: {
    total: function () {
      return helpers.formatarValor(
        this.form.quantidade * helpers.removerValor(this.form.valorIndividual)
      );
    },
  },
};
</script>
<style>
    .lista-arquivos{
        border: 1px solid #e5e5e5;
        background: #f9f9f9;
    }
    .lista-arquivos__no_top{
        border-top: none;
    }
    .lista-arquivos__left{
        border-left: 1px solid #e5e5e5;
    }
</style>
